import { DoricPlugin } from "../DoricPlugin";
import { DoricElement } from "../DoricElement";
export class NavigatorPlugin extends DoricPlugin {
    constructor() {
        super(...arguments);
        this.navigation = document.getElementsByTagName('doric-navigation')[0];
    }
    push(args) {
        var _a;
        if (this.navigation) {
            const div = new DoricElement;
            div.src = args.source;
            div.alias = ((_a = args.config) === null || _a === void 0 ? void 0 : _a.alias) || args.source;
            this.navigation.push(div);
            return Promise.resolve();
        }
        else {
            return Promise.reject('Not implemented');
        }
    }
    pop() {
        if (this.navigation) {
            this.navigation.pop();
            return Promise.resolve();
        }
        else {
            return Promise.reject('Not implemented');
        }
    }
}
//# sourceMappingURL=NavigatorPlugin.js.map